import { createRef, useEffect, useState } from 'react';

const computeRefTopOffset = (ref) => {
  const { current } = ref;
  if (current) {
    const offsetTop = current.offsetTop;
    const parentTopPaddingOffset = 8;

    // if this bladeLevel is a child we also need the parent offsetTop
    const parentOffsetTop = current.offsetParent?.offsetTop || 0;

    return offsetTop + parentOffsetTop - parentTopPaddingOffset;
  }
};

export default function useBladeItemPositioning<T extends HTMLButtonElement>() {
  const [top, setTop] = useState<number>(undefined);
  const itemRef = createRef<T>();

  useEffect(() => {
    const computedTop = computeRefTopOffset(itemRef);
    if (top !== computedTop) setTop(computedTop);
  }, [top, itemRef]);

  return { top, itemRef };
}
